import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-diretoria-executiva',
  templateUrl: './diretoria-executiva.component.html',
  styleUrls: ['./diretoria-executiva.component.css']
})
export class DiretoriaExecutivaComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
